module.exports = __webpack_public_path__ + "static/media/design2.3a535b82.jpg";